module.exports = __webpack_public_path__ + "static/media/undraw_real-time-analytics_50za.de6ce4d6.svg";